export default "__VITE_ASSET__ByTjmVy$__"